import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3994a55e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "clearfix-pic"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "Upload", -1))
const _hoisted_5 = {
  key: 2,
  class: "clearfix-pic"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_TEditor = _resolveComponent("TEditor")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: _ctx.editInfo.setValidateForm,
    model: _ctx.form,
    rules: _ctx.rules,
    "label-col": { span: _ctx.layoutConfig.label },
    "wrapper-col": { span: _ctx.layoutConfig.wrapper }
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formConfig, (item, key) => {
        return (_openBlock(), _createBlock(_component_a_form_item, {
          key: key,
          label: item.name,
          name: key
        }, {
          default: _withCtx(() => [
            (item.type === 'text')
              ? (_openBlock(), _createBlock(_component_a_input, {
                  key: 0,
                  value: _ctx.form[key],
                  "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                  allowClear: item.clearable !== false,
                  placeholder: `请输入${item.placeholder?item.placeholder:item.name}`,
                  style: _normalizeStyle({ width: item.width ? item.width + 'px' : '' })
                }, null, 8, ["value", "onUpdate:value", "allowClear", "placeholder", "style"]))
              : (item.type === 'image')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_a_upload, {
                      "file-list": _ctx.editInfo.cacheFileList[key],
                      "onUpdate:fileList": ($event: any) => ((_ctx.editInfo.cacheFileList[key]) = $event),
                      name: "uploadedfile",
                      "list-type": "picture-card",
                      class: "avatar-uploader",
                      "show-upload-list": false,
                      action: _ctx.editInfo.getFileUploadUrl(),
                      "before-upload": _ctx.editInfo.beforeUpload,
                      headers: _ctx.editInfo.imgHeader,
                      data: _ctx.editInfo.imageParam,
                      onChange: ($event: any) => (_ctx.editInfo.handleChange($event,key))
                    }, {
                      default: _withCtx(() => [
                        (_ctx.editInfo.cacheImageUrl[key])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              width: "103",
                              height: "103",
                              src: _ctx.editInfo.cacheImageUrl[key],
                              alt: "avatar"
                            }, null, 8, _hoisted_2))
                          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (_ctx.editInfo.loading)
                                ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                              _hoisted_4
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["file-list", "onUpdate:fileList", "action", "before-upload", "headers", "data", "onChange"])
                  ]))
                : (item.type === 'file')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_a_upload, {
                        name: "uploadedfile",
                        action: _ctx.editInfo.getFileUploadUrl(),
                        "file-list": _ctx.editInfo.cacheFileList[key],
                        multiple: false,
                        "before-upload": _ctx.editInfo.beforeUpload
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_upload_outlined),
                              _createTextVNode(" 选择文件 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["action", "file-list", "before-upload"])
                    ]))
                  : (item.type === 'textarea')
                    ? (_openBlock(), _createBlock(_component_a_textarea, {
                        key: 3,
                        value: _ctx.form[key],
                        "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                        allowClear: item.clearable !== false,
                        autoSize: { minRows: 2, maxRows: 6 },
                        placeholder: `请输入${item.name}`,
                        style: _normalizeStyle({ width: item.width ? item.width + 'px' : '' })
                      }, null, 8, ["value", "onUpdate:value", "allowClear", "placeholder", "style"]))
                    : (item.type === 'switch')
                      ? (_openBlock(), _createBlock(_component_a_switch, {
                          key: 4,
                          checked: _ctx.form[key] === 1,
                          onChange: ($event: any) => (_ctx.editInfo.switchImgStatus($event,key))
                        }, null, 8, ["checked", "onChange"]))
                      : (item.type === 'richText')
                        ? (_openBlock(), _createBlock(_component_TEditor, {
                            key: 5,
                            value: _ctx.form[key],
                            "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event)
                          }, null, 8, ["value", "onUpdate:value"]))
                        : (item.type === 'date')
                          ? (_openBlock(), _createBlock(_component_a_date_picker, {
                              key: 6,
                              type: "date",
                              value: _ctx.form[key],
                              "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                              style: _normalizeStyle({ width: item.width ? item.width + 'px' : '' }),
                              "show-time": item.showTime,
                              placeholder: `请选择${item.name}`,
                              allowClear: item.clearable !== false
                            }, null, 8, ["value", "onUpdate:value", "style", "show-time", "placeholder", "allowClear"]))
                          : (item.type === 'dateRange')
                            ? (_openBlock(), _createBlock(_component_a_range_picker, {
                                key: 7,
                                type: "date",
                                value: _ctx.form[key],
                                "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                                style: _normalizeStyle({ width: item.width ? item.width + 'px' : '' }),
                                "show-time": item.showTime,
                                placeholder: `请选择${item.name}`,
                                allowClear: item.clearable !== false,
                                getCalendarContainer: (triggerNode) => triggerNode.parentNode
                              }, null, 8, ["value", "onUpdate:value", "style", "show-time", "placeholder", "allowClear", "getCalendarContainer"]))
                            : (item.type === 'select')
                              ? (_openBlock(), _createBlock(_component_a_select, {
                                  key: 8,
                                  "show-search": "",
                                  value: _ctx.form[key],
                                  "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                                  allowClear: item.clearable !== false,
                                  disabled: item.disabled === true,
                                  placeholder: `请下拉选择${item.name}`,
                                  style: _normalizeStyle({ width: item.width ? item.width + 'px' : '' }),
                                  filterOption: _ctx.editInfo.filterOption,
                                  getPopupContainer: (triggerNode) => triggerNode.parentNode
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (option) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        value: option.value,
                                        key: option.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value", "allowClear", "disabled", "placeholder", "style", "filterOption", "getPopupContainer"]))
                              : (item.type === 'multiple')
                                ? (_openBlock(), _createBlock(_component_a_select, {
                                    key: 9,
                                    value: _ctx.form[key],
                                    "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                                    mode: item.type,
                                    allowClear: item.clearable !== false,
                                    disabled: item.disabled === true,
                                    placeholder: `请下拉选择${item.name}`,
                                    onChange: ($event: any) => (_ctx.editInfo.onChange($event, key)),
                                    filterOption: _ctx.editInfo.filterOption
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (option) => {
                                        return (_openBlock(), _createBlock(_component_a_select_option, {
                                          value: option.value,
                                          key: option.value
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(option.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["value", "onUpdate:value", "mode", "allowClear", "disabled", "placeholder", "onChange", "filterOption"]))
                                : (item.type === 'number')
                                  ? (_openBlock(), _createBlock(_component_a_input_number, {
                                      key: 10,
                                      value: _ctx.form[key],
                                      "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                                      min: item.min,
                                      max: item.max,
                                      disabled: item.disabled === true
                                    }, null, 8, ["value", "onUpdate:value", "min", "max", "disabled"]))
                                  : (item.type === 'radio')
                                    ? (_openBlock(), _createBlock(_component_a_radio_group, {
                                        key: 11,
                                        value: _ctx.form[key],
                                        "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                                        disabled: item.disabled === true,
                                        onChange: _ctx.editInfo.onRadioChange
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (radioItem) => {
                                            return (_openBlock(), _createBlock(_component_a_radio, {
                                              key: radioItem.key,
                                              value: radioItem.key
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(radioItem.value), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["value", "onUpdate:value", "disabled", "onChange"]))
                                    : (item.type === 'checkbox')
                                      ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
                                          key: 12,
                                          value: _ctx.form[key],
                                          "onUpdate:value": ($event: any) => ((_ctx.form[key]) = $event),
                                          options: item.data,
                                          disabled: item.disabled === true
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (checkItem) => {
                                              return (_openBlock(), _createBlock(_component_a_checkbox, {
                                                key: checkItem.key,
                                                label: checkItem.key
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(checkItem.value), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["label"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["value", "onUpdate:value", "options", "disabled"]))
                                      : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["label", "name"]))
      }), 128)),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}